module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1200-a2f74248e013ebad4057f152fd9989b1.jpg";